<template>
  <DragDialog
    title="转换配置"
    :width="500"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel"
    class="dialog-primary-custom">
    <div class="tip-box">
      <div>注：rgba代表原有方式，intensity代表使用反射率</div>
    </div>
    <div class="config-content-box">
      <div class="label dialog-label">点云着色方式：</div>
      <div class="common-radio-box radio-primary">
        <el-radio
          v-model="coloringMode"
          :label="0"
          >rgba</el-radio
        >
        <el-radio
          v-model="coloringMode"
          :label="1"
          >intensity</el-radio
        >
      </div>
    </div>

    <div class="common-button-box dialog-footer">
      <el-button
        size="small"
        class="hollowOut-btn gr8 primary-ang-btn"
        @click="cancel"
        >取消</el-button
      >
      <el-button
        type="primary"
        size="small"
        class="primary-btn gr8 primary-ang-btn"
        @click="submit"
        >转换</el-button
      >
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'

import {
  pointCloudConvertConfigService,
  pointCloudBatchConvertConfigService
} from '@/service/interface'

export default {
  data() {
    return {
      coloringMode: 0
    }
  },
  props: {
    visible: Boolean,
    dataSetsToConvert: Array,
    submitConvert: Function,
    closeDialog: Function
  },
  components: {
    DragDialog
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initColoringMode()
      }
    }
  },
  methods: {
    initColoringMode() {
      if (this.dataSetsToConvert.length > 1) {
        this.coloringMode = 0
      } else {
        let dataSetInfo = this.dataSetsToConvert[0]
        if (dataSetInfo.convertConfig) {
          this.coloringMode = dataSetInfo.convertConfig.coloringMode
        } else {
          this.coloringMode = 0
        }
      }
    },
    submit() {
      this.configConvertParams().then(() => {
        this.submitConvert()
        this.cancel()
      })
    },
    configConvertParams() {
      return new Promise(resolve => {
        if (this.dataSetsToConvert.length > 1) {
          let dataSetIds = this.dataSetsToConvert.map(el => el.dataSetId)
          let params = { dataSetIds, coloringMode: 0 }
          pointCloudBatchConvertConfigService(params).then(response => {
            if (response.isSuccess) {
              resolve()
            } else {
              this.$message.error(response.errMsg)
            }
          })
        } else {
          let dataSetId = this.dataSetsToConvert[0].dataSetId
          let params = {
            dataSetId,
            coloringMode: this.coloringMode
          }
          pointCloudConvertConfigService(params).then(response => {
            if (response.isSuccess) {
              resolve()
            } else {
              this.$message.error(response.errMsg)
            }
          })
        }
      })
    },
    cancel() {
      this.coloringMode = 0

      this.closeDialog()
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.config-content-box {
  display: flex;
  align-items: center;
  color: var(--default-color);
  margin-bottom: 16px;

  .common-radio-box {
    display: flex;
    margin: 5px 0px;
  }
}

.tip-box {
  display: flex;
  margin-bottom: 16px;
  align-items: center;
  color: var(--page-tips-text-color);
  // background-color: var(--base-bg-dark-color33);
  font-size: 12px;
  font-weight: 400;
  padding: 5px 16px;
  margin: -16px;
  margin-top: -16px;
  margin-bottom: 2px;
  box-sizing: content-box;
}

.common-button-box {
  text-align: right;
}

.dialog-primary-custom {
  :deep(.dialog-content) {
    padding-bottom: 0 !important;
  }

  :deep(.dialog-content) {
    position: relative;

    .tip-box {
      // position: absolute;
      // top: 0;
    }
  }

  .dialog-footer {
    margin: 0 -16px;
    box-sizing: content-box;
  }
}
</style>
